<!-- WRITE -->
@if (!readonly){
  <p-multiSelect 
    [ngModelOptions]="{standalone: true}"

    [placeholder]="'SelectOptions' | translate" 
    
    [options]="options"
    [(ngModel)]="selectedOptions"
    
    [showHeader]="false"
    [showClear]="true"

    (ngModelChange)="updateChanges($event);"

    styleClass="w-100"

    appendTo="body"
    [overlayOptions]="{
        baseZIndex: 1055
    }"
  >
  <ng-template let-x pTemplate="selectedItem">
          <div class="flex align-items-center gap-2">
            <div>
              {{ x.label }} 
              <b *ngIf="x.price">
                +{{ x.price | appCurrencyPipe }}
              </b>
            </div>
          </div>
        </ng-template>
        <ng-template let-x pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>
              {{ x.label }} 
              <b *ngIf="x.price">
                +{{ x.price | appCurrencyPipe}}
              </b>
            </div>
          </div>
        </ng-template>
  </p-multiSelect>
}

<!-- READ -->
@if (readonly){
  @if (selectedOptions){
    <span>{{ selectedOptionsString }}</span>
  }
  
}
